module.exports = __webpack_public_path__ + "static/img/SketchPngc06a197ef7a9500c790ed5b32d00a4485bc2a7b49f9fb4542b876857ebba4c71.6e72ff58.png";